"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSurrogatePair = void 0;
const assertString_1 = require("./util/assertString");
const surrogatePair = /[\uD800-\uDBFF][\uDC00-\uDFFF]/;
function isSurrogatePair(str) {
    (0, assertString_1.assertString)(str);
    return surrogatePair.test(str);
}
exports.isSurrogatePair = isSurrogatePair;
